import { useApiGetter, useApiEffect, OrganizationService } from '@localstack/services';
import { COUNTRY_MAP } from '@localstack/constants';

import { Stack, Typography } from '@mui/material';

import { Divider, GridComponent } from '../utils';

import { OrgDetailsDialog } from './OrgDetailsDialog';
import { TaxIdentifierDialog } from './TaxIdentifierDialog';

export const BillingDetails = (): JSX.Element => {
  const { data: organization } = useApiGetter(OrganizationService, 'getOrganization', []);

  const { patchOrganization, isLoading: isUpdatingOrg } = useApiEffect(OrganizationService, ['patchOrganization'], {
    revalidate: ['getOrganization'],
  });

  const isAddressComplete =
    organization?.billing_details.address &&
    organization?.billing_details.zip &&
    organization?.billing_details.city &&
    organization?.billing_details.country;

  if (!organization) {
    return (
      <GridComponent columns="1fr">
        <Typography color="text.tertiary">Fetching your billing data...</Typography>
      </GridComponent>
    );
  }

  return (
    <GridComponent columns="1fr max-content">
      <Stack gap="2px">
        <Typography color="text.primary" fontWeight={500}>
          {organization?.basic_details.name}
        </Typography>
        {isAddressComplete && (
          <Typography color="text.tertiary">
            {organization?.billing_details.address}, {organization?.billing_details?.zip}{' '}
            {organization?.billing_details?.city},{' '}
            {COUNTRY_MAP[organization?.billing_details.country as keyof typeof COUNTRY_MAP]}
          </Typography>
        )}
        <Typography color="text.tertiary">{organization?.billing_details?.email}</Typography>
      </Stack>
      <OrgDetailsDialog
        basicDetails={organization?.basic_details}
        billingDetails={organization?.billing_details}
        onSubmit={patchOrganization}
        isUpdatingOrg={isUpdatingOrg}
      />
      <Divider />
      {!organization?.tax_details.tax_id ? (
        <Typography color="text.tertiary">No tax identifier on file</Typography>
      ) : (
        <Stack gap="2px">
          <Typography color="text.primary" fontWeight={500}>
            Tax Identifier
          </Typography>
          <Typography color="text.tertiary">{organization.tax_details.tax_id}</Typography>
        </Stack>
      )}
      <TaxIdentifierDialog
        country={organization?.billing_details.country}
        taxDetails={organization.tax_details}
        onSubmit={patchOrganization}
        isUpdatingOrg={isUpdatingOrg}
      />
    </GridComponent>
  );
};
